import { cn } from "@exhousing/design-system";
import { useSearchParams } from "react-router-dom";

import { AccountsTable } from "@/components/crm/AccountsTable";
import { CrmStatsHeader } from "@/components/crm/CrmStatsHeader";
import { FollowUpsList } from "@/components/crm/FollowUpsList";
import { PipelineBoard } from "@/components/crm/PipelineBoard";

const TABS = [
  { id: "pipeline", label: "Pipeline" },
  { id: "accounts", label: "Accounts" },
  { id: "followups", label: "Follow-ups" },
] as const;

type Tab = (typeof TABS)[number]["id"];

export function CrmPage() {
  const [params, setParams] = useSearchParams();
  const requested = params.get("tab") as Tab | null;
  const tab: Tab = TABS.some((t) => t.id === requested) ? (requested as Tab) : "pipeline";
  const setTab = (t: Tab) => setParams({ tab: t });

  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-display text-3xl font-medium tracking-tight">CRM</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Acquisition pipeline, corporate accounts and your follow-ups — one workspace.
        </p>
      </header>

      <CrmStatsHeader />

      <div className="flex gap-1 overflow-x-auto border-b border-border">
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={cn(
              "-mb-px whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium transition-colors",
              tab === t.id
                ? "border-primary text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground",
            )}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "pipeline" && <PipelineBoard />}
      {tab === "accounts" && <AccountsTable />}
      {tab === "followups" && <FollowUpsList />}
    </div>
  );
}
